(() => {
  if (window.__WN_PRODUCT_STICKY_ATC_V3__) return;
  window.__WN_PRODUCT_STICKY_ATC_V3__ = true;

  const copy=window.WN_I18N?.product||{};
  const normalize=value=>{
    try{return new URL(value||location.pathname,location.origin).pathname.replace(/\/$/,'')||'/';}
    catch{return String(value||location.pathname).replace(/\/$/,'')||'/';}
  };
  const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mount(root){
    if(!root || root.dataset.productStickyReady==='true') return;
    const rail=root.querySelector('[data-product-sticky-target],[data-wn-sticky-target]');
    if(!rail) return;

    const productKey=normalize(root.dataset.productUrl);
    const form=[...document.querySelectorAll('wn-product-form')].find(candidate=>normalize(candidate.dataset.productUrl)===productKey)
      || document.querySelector('wn-product-form');
    const htmlForm=form?.querySelector('[data-type="product-form"]');
    const mainButton=htmlForm?.querySelector('[data-add-to-cart]');
    const button=rail.querySelector('[data-product-rail-add],[data-wn-sticky-add]');
    if(!form||!htmlForm||!mainButton||!button) return;

    root.dataset.productStickyReady='true';
    const controller=new AbortController();
    root.productStickyAbortController=controller;
    const {signal}=controller;
    const price=rail.querySelector('[data-product-rail-price]');
    const variantName=rail.querySelector('[data-product-rail-variant]');
    const image=rail.querySelector('[data-product-rail-image]');
    const productSection=form.closest('[data-main-product-section]')||form;
    const threshold=Math.max(0,Number(root.dataset.scrollThreshold||120));
    const addLabel=root.dataset.buttonLabel||copy.add||'Add';
    const soldOutLabel=root.dataset.soldOutLabel||copy.notAvailable||'Unavailable';
    let variants=[];
    let currentVariant=null;
    let purchaseState=null;
    let frame=0;

    try{
      variants=JSON.parse(rail.querySelector('[data-product-rail-variants]')?.textContent||'[]');
    }catch{variants=[];}

    const getVariantFromForm=()=>{
      const id=form.querySelector('[data-variant-id]')?.value;
      return variants.find(v=>String(v.id)===String(id))||null;
    };

    const renderVariant=variant=>{
      if(!variant) return;
      currentVariant=variant;
      if(price) price.textContent=variant.price_formatted||price.textContent;
      if(variantName){
        const title=String(variant.title||'');
        variantName.hidden=!title||title==='Default Title';
        variantName.textContent=variantName.hidden?'':title;
      }
      if(image && variant.featured_image_url){
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src=variant.featured_image_url;
        image.alt=variant.featured_image_alt||'';
      }
      const unavailable=variant.available===false;
      button.disabled=unavailable;
      button.textContent=unavailable?soldOutLabel:addLabel;
    };

    const renderPurchase=state=>{
      if(!state) return;
      purchaseState=state;
      if(price) price.textContent=state.priceFormatted||price.textContent;
      if(variantName){
        const label=String(state.displayLabel||state.label||'');
        if(label){variantName.hidden=false;variantName.textContent=label;}
      }
      const unavailable=state.available===false;
      button.disabled=unavailable;
      button.textContent=unavailable?soldOutLabel:addLabel;
    };

    const syncVariant=()=>{
      const variant=getVariantFromForm();
      if(variant) renderVariant(variant);
      if(purchaseState) renderPurchase(purchaseState);
    };

    const ownEvent=event=>{
      const source=event.target instanceof Element?event.target.closest('wn-product-form'):null;
      return !source||source===form;
    };

    const updateVisibility=()=>{
      frame=0;
      const rect=productSection.getBoundingClientRect();
      const visible=rect.bottom<=Math.max(threshold,window.innerHeight*.14);
      rail.hidden=false;
      rail.classList.toggle('is-visible',visible);
      rail.setAttribute('aria-hidden',String(!visible));
      if(visible) rail.removeAttribute('inert'); else rail.setAttribute('inert','');
    };
    const scheduleVisibility=()=>{if(!frame) frame=requestAnimationFrame(updateVisibility);};

    button.addEventListener('click',event=>{
      event.preventDefault();
      if(mainButton.disabled){
        form.scrollIntoView({behavior:reduceMotion()?'auto':'smooth',block:'center'});
        return;
      }
      if(typeof htmlForm.requestSubmit==='function') htmlForm.requestSubmit(); else mainButton.click();
    },{signal});

    document.addEventListener('wn:product:variant-change',event=>{
      if(!ownEvent(event)) return;
      const raw=event.detail?.variant;
      const mapped=variants.find(v=>String(v.id)===String(raw?.id))||getVariantFromForm();
      renderVariant(mapped||raw);
      if(purchaseState) renderPurchase(purchaseState);
    },{signal});

    form.addEventListener('click',event=>{
      if(!event.target.closest('[data-option-value]')) return;
      requestAnimationFrame(()=>requestAnimationFrame(syncVariant));
    },{signal});
    form.addEventListener('change',()=>requestAnimationFrame(syncVariant),{signal});

    const onPurchase=event=>{
      const detail=event.detail||{};
      const eventKey=normalize(detail.productUrl||detail.state?.productUrl||'');
      if(eventKey && eventKey!==productKey) return;
      renderPurchase(detail.state||detail);
    };
    document.addEventListener('wn:product:purchase-state-change',onPurchase,{signal});
    document.addEventListener('wn:nami:purchase-state-change',onPurchase,{signal});
    document.addEventListener('wn:product:add-start',event=>{if(ownEvent(event)){button.disabled=true;button.textContent=copy.adding||addLabel;}},{signal});
    document.addEventListener('wn:product:add-success',event=>{
      if(!ownEvent(event)) return;
      button.textContent=copy.addedToCart||addLabel;
      window.setTimeout(()=>{
        button.disabled=currentVariant?.available===false||purchaseState?.available===false;
        button.textContent=button.disabled?soldOutLabel:addLabel;
      },1200);
    },{signal});
    document.addEventListener('wn:product:add-error',event=>{
      if(!ownEvent(event)) return;
      button.disabled=currentVariant?.available===false||purchaseState?.available===false;
      button.textContent=button.disabled?soldOutLabel:addLabel;
    },{signal});

    window.addEventListener('scroll',scheduleVisibility,{passive:true,signal});
    window.addEventListener('resize',scheduleVisibility,{passive:true,signal});
    window.addEventListener('pageshow',scheduleVisibility,{passive:true,signal});

    currentVariant=getVariantFromForm()||variants[0]||form.currentVariant||null;
    if(currentVariant) renderVariant(currentVariant);
    const stored=window.__WN_PRODUCT_PURCHASE_STATE__?.[productKey]||window.__WN_NAMI_PURCHASE_STATE__?.[productKey];
    if(stored) renderPurchase(stored);
    rail.hidden=false;
    scheduleVisibility();
  }

  const mountAll=(scope=document)=>{
    if(scope.matches?.('[data-product-sticky-atc]')) mount(scope);
    scope.querySelectorAll?.('[data-product-sticky-atc]').forEach(mount);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>mountAll(),{once:true}); else mountAll();
  document.addEventListener('shopify:section:load',event=>mountAll(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll?.('[data-product-sticky-ready="true"]').forEach(section=>section.productStickyAbortController?.abort());
  });
})();